var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1442 5109 c-46 -14 -109 -80 -122 -129 -7 -27 -10 -179 -8 -463 l3 -422 24 -38 c13 -21 42 -50 64 -65 34 -23 52 -27 107 -27 55 0 73 4 107 27 22 15 51 44 64 65 24 38 24 42 27 351 l3 312 1430 0 1429 0 0 -2160 0 -2160 -1429 0 -1430 0 -3 313 c-3 308 -3 312 -27 350 -13 21 -42 50 -64 65 -34 23 -52 27 -107 27 -55 0 -73 -4 -107 -27 -22 -15 -51 -44 -64 -65 l-24 -38 0 -445 0 -445 24 -38 c13 -21 42 -50 64 -65 l41 -27 1696 0 1696 0 41 27 c22 15 51 44 64 65 l24 38 0 2426 0 2425 -27 41 c-15 22 -44 51 -65 64 l-38 24 -1680 2 c-1042 1 -1692 -2 -1713 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905 3291 c-97 -25 -167 -127 -150 -220 11 -60 34 -92 143 -203 l105 -108 -860 -2 -859 -3 -41 -27 c-62 -41 -88 -90 -88 -168 0 -78 26 -127 88 -168 l41 -27 859 -3 860 -2 -105 -108 c-109 -111 -132 -143 -143 -203 -14 -74 36 -168 109 -206 51 -26 133 -22 186 9 25 15 170 152 322 305 288 289 318 327 318 403 0 76 -30 114 -318 403 -152 153 -295 289 -317 302 -45 27 -106 38 -150 26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check-in.46a8742e88120cacffb08961677d9840.svg";
export { ForwardRef as ReactComponent };